import React from 'react'
import { DownOutlined } from '@ant-design/icons'

export default function SupplierOrders({ count, selected, children }: {
  count: number; selected: number; children: React.ReactNode
}) {
  return <details className="delivery-calendar__orders">
    <summary className="delivery-calendar__orders-toggle">
      <span className="delivery-calendar__orders-title"><DownOutlined className="delivery-calendar__orders-arrow" />Заказы и заявки <span className="delivery-calendar__orders-count">{count}</span></span>
      {selected > 0 && <span className="delivery-calendar__orders-selected">Выбрано: {selected}</span>}
    </summary>
    <div className="delivery-calendar__orders-content">{children}</div>
  </details>
}
